import script from "./PageDirector.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageDirector.vue?vue&type=script&setup=true&lang=ts"

import "./PageDirector.vue?vue&type=style&index=0&id=2ef736d2&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef736d2"]])

export default __exports__